import { Copy, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { pct } from "@/lib/referral";

export function ReferralLinkCard({ link, program }) {
  const copy = () => navigator.clipboard.writeText(link).then(() => toast.success("Link copiado")).catch(() => toast.error("Não foi possível copiar"));
  const share = `https://wa.me/?text=${encodeURIComponent(`Conheça o sistema que eu uso no meu negócio. Comece com teste grátis: ${link}`)}`;
  return (
    <div className="card-surface space-y-3 p-5" data-testid="referral-link-card">
      <p className="eyebrow">Seu link de indicação</p>
      <div className="flex flex-col gap-2 sm:flex-row">
        <Input readOnly value={link} onFocus={(e) => e.target.select()} className="font-mono text-sm" data-testid="referral-link-input" />
        <Button onClick={copy} data-testid="referral-copy-btn"><Copy className="mr-1 h-4 w-4" />Copiar</Button>
        <Button variant="outline" asChild><a href={share} target="_blank" rel="noreferrer" data-testid="referral-whatsapp-btn"><MessageCircle className="mr-1 h-4 w-4" />WhatsApp</a></Button>
      </div>
      <p className="text-sm text-muted-foreground" data-testid="referral-program-text">
        {program.active
          ? `Você ganha ${pct(program.percent)} de cada mensalidade paga por quem se cadastrar pelo seu link. Fechamento ${program.frequency_label.toLowerCase()}, pago via Pix.`
          : "O programa de indicações está pausado no momento. Seu link continua guardando quem se cadastrar por ele."}
      </p>
    </div>
  );
}
